/*
  Quick add from product cards: choose a size, add with the Ajax Cart API, open Dawn's cart drawer
  (rendered through the Section Rendering API). No page reload.

  FitCore: the card passes its garment type (snippets/ls-garment.liquid). If the shopper has used
  FitCore, their saved size for that garment (localStorage 'fitcore:sizes', written by the FitCore
  app) is pre-selected and labelled. "Find my size" opens FitCore when its launcher is on the page,
  otherwise it links to the product page. New FitCore results update the sheet live.

  After adding it publishes Dawn's cartUpdate event and a 'cart:add' DOM event (used by ls-tracking).
*/
(() => {
  const sheet = document.getElementById('LsQuickAdd');
  if (!sheet) return;

  const $ = (sel) => sheet.querySelector(sel);
  const panel = $('.ls-qa__panel');
  const addButton = $('[data-ls-qa-add]');
  const status = $('[data-ls-qa-status]');
  const SIZE_OPTION = /size|waist|collar|chest|fitting/i;
  const FITCORE_KEY = { suit: 'size', shirt: 'shirt', trouser: 'trouser', casual: 'casual', shoe: 'shoe' };
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cache = new Map();
  let state = null;

  const money = (cents) => {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    // Pounds show plain (£199.95); other currencies add their code (e.g. $300.00 USD), matching snippets/ls-money
    const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' }).format(cents / 100);
    return currency === 'GBP' ? amount : `${amount} ${currency}`;
  };
  const norm = (v) => String(v || '').toUpperCase().replace(/\s+/g, '');

  // FitCore and the catalogue label sizes differently ('16.5" / 42cm' vs 'UK16.5 / EU42',
  // '34R long leg' vs '34R', 'L' vs 'Large'). Compare the UK number plus S/R/L fitting, or the letter size.
  const ALPHA = { XS: 'XS', S: 'S', SMALL: 'S', M: 'M', MEDIUM: 'M', L: 'L', LARGE: 'L', XL: 'XL', XLARGE: 'XL', XXL: 'XXL', '2XL': 'XXL', XXLARGE: 'XXL', XXXL: '3XL', '3XL': '3XL' };
  function sizeKey(value) {
    const s = String(value || '').toUpperCase();
    const m = s.match(/UK\s*(\d+(?:\.\d+)?)\s*([SRL])?(?![A-Z])/) || s.match(/(\d+(?:\.\d+)?)\s*([SRL])?(?![A-Z])/);
    if (m) return { n: parseFloat(m[1]), fit: m[2] || '' };
    const alpha = ALPHA[s.replace(/[^A-Z0-9]/g, '')];
    return alpha ? { a: alpha } : null;
  }
  function sameSize(a, b) {
    const ka = sizeKey(a);
    const kb = sizeKey(b);
    if (!ka || !kb) return norm(a) === norm(b);
    if (ka.a || kb.a) return Boolean(ka.a) && ka.a === kb.a;
    return ka.n === kb.n && (!ka.fit || !kb.fit || ka.fit === kb.fit);
  }

  // Shared with the product page (assets/ls-product.js).
  window.lsSize = { sameSize: (a, b) => sameSize(a, b), fitcoreSize: (g) => fitcoreSize(g) };

  function fitcoreSize(garment) {
    try {
      const saved = JSON.parse(localStorage.getItem('fitcore:sizes') || 'null');
      return (saved && saved[FITCORE_KEY[garment]]) || '';
    } catch (e) {
      return '';
    }
  }

  async function fetchProduct(handle) {
    if (!cache.has(handle)) {
      cache.set(
        handle,
        fetch(`${root}products/${encodeURIComponent(handle)}.js`).then((r) => {
          if (!r.ok) throw new Error(r.status);
          return r.json();
        })
      );
    }
    return cache.get(handle);
  }

  function matchingVariant() {
    return state.product.variants.find((v) => v.options.every((val, i) => state.selected[i] === val));
  }

  function valueAvailable(optionIndex, value) {
    return state.product.variants.some(
      (v) => v.available && v.options.every((val, i) => (i === optionIndex ? val === value : !state.selected[i] || state.selected[i] === val))
    );
  }

  function renderOptions() {
    const wrap = $('[data-ls-qa-options]');
    wrap.innerHTML = '';
    state.product.options.forEach((option, i) => {
      if (option.values.length < 2) return;
      const fieldset = document.createElement('fieldset');
      fieldset.className = 'ls-qa__option';
      const legend = document.createElement('legend');
      legend.className = 'ls-qa__legend';
      legend.textContent = option.name;
      fieldset.appendChild(legend);
      const chips = document.createElement('div');
      chips.className = 'ls-chips';
      option.values.forEach((value, j) => {
        const id = `LsQa-${i}-${j}`;
        const available = valueAvailable(i, value);
        const input = Object.assign(document.createElement('input'), {
          type: 'radio',
          name: `ls-qa-${option.name}`,
          id,
          value,
          className: 'ls-qa__radio visually-hidden',
          checked: state.selected[i] === value,
        });
        const label = document.createElement('label');
        label.htmlFor = id;
        label.className = `ls-chip${available ? '' : ' ls-chip--out'}${state.fitIndex === i && state.fitSize && sameSize(value, state.fitSize) ? ' ls-chip--fit' : ''}`;
        label.textContent = value;
        if (!available) label.insertAdjacentHTML('beforeend', '<span class="visually-hidden">, sold out</span>');
        input.addEventListener('change', () => {
          state.selected[i] = value;
          renderOptions();
          update();
          document.getElementById(id)?.focus();
        });
        chips.append(input, label);
      });
      fieldset.appendChild(chips);
      wrap.appendChild(fieldset);
    });
  }

  function renderFit() {
    const box = $('[data-ls-qa-fit]');
    if (!state.garment || state.fitIndex < 0) {
      box.hidden = true;
      return;
    }
    box.hidden = false;
    const text = $('[data-ls-qa-fit-text]');
    const fab = document.getElementById('fitcore-fab');
    $('[data-ls-qa-fitcore]').hidden = !fab;
    const link = $('[data-ls-qa-fitcore-link]');
    link.hidden = Boolean(fab);
    link.href = `${state.product.url}#size`;
    if (state.fitSize) {
      const offered = state.product.options[state.fitIndex].values.find((v) => sameSize(v, state.fitSize));
      text.textContent = offered ? `Your FitCore size: ${offered}` : `Your FitCore size (${state.fitSize}) isn't made in this style.`;
    } else {
      text.textContent = 'Not sure of your size?';
    }
  }

  function update() {
    const variant = matchingVariant();
    const lead = $('[data-ls-qa-lead]');
    status.textContent = '';
    lead.hidden = true;
    if (!variant) {
      const missing = state.product.options.find((o, i) => !state.selected[i]);
      addButton.disabled = true;
      addButton.textContent = missing ? `Select a ${missing.name.toLowerCase()}` : 'Unavailable';
      $('[data-ls-qa-price]').textContent = money(state.product.price);
      return;
    }
    $('[data-ls-qa-price]').textContent = money(variant.price);
    $('[data-ls-qa-details]').href = `${state.product.url}?variant=${variant.id}`;
    if (variant.available) {
      addButton.disabled = false;
      addButton.textContent = `Add to bag · ${money(variant.price)}`;
      const note = state.delivery && state.delivery[variant.id];
      if (note) {
        lead.textContent = note;
        lead.hidden = false;
      }
    } else {
      addButton.disabled = true;
      addButton.textContent = 'Sold out in this size';
    }
  }

  function preselect() {
    state.selected = state.product.options.map((o) => (o.values.length === 1 ? o.values[0] : null));
    state.fitIndex = state.product.options.findIndex((o) => SIZE_OPTION.test(o.name));
    state.fitSize = state.garment ? fitcoreSize(state.garment) : '';
    if (state.fitIndex > -1 && state.fitSize) {
      const match = state.product.options[state.fitIndex].values.find((v) => sameSize(v, state.fitSize));
      if (match && valueAvailable(state.fitIndex, match)) state.selected[state.fitIndex] = match;
    }
  }

  async function open(trigger) {
    const { handle, garment, variantId } = trigger.dataset;
    let delivery = {};
    try { delivery = JSON.parse(trigger.dataset.delivery || '{}'); } catch (e) {}
    if (variantId) return add(Number(variantId), trigger, delivery[variantId]);

    trigger.setAttribute('aria-busy', 'true');
    let product;
    try {
      product = await fetchProduct(handle);
    } catch (e) {
      window.location.href = `${root}products/${handle}`;
      return;
    } finally {
      trigger.removeAttribute('aria-busy');
    }

    state = { product, garment: garment || '', trigger, selected: [], fitIndex: -1, fitSize: '', delivery };
    preselect();

    $('[data-ls-qa-vendor]').textContent = product.vendor;
    $('#LsQuickAddTitle').textContent = product.title;
    $('[data-ls-qa-details]').href = product.url;
    const img = $('.ls-qa__img');
    if (product.featured_image) {
      img.src = `${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=200`;
      img.hidden = false;
    } else img.hidden = true;

    renderOptions();
    renderFit();
    update();

    sheet.hidden = false;
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    if (typeof trapFocus === 'function') trapFocus(panel, sheet.querySelector('.ls-qa__radio:checked') || sheet.querySelector('.ls-qa__radio') || addButton);
  }

  function close() {
    if (sheet.hidden) return;
    sheet.classList.remove('is-open');
    sheet.hidden = true;
    document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(state && state.trigger);
    else state?.trigger?.focus();
  }

  async function add(variantId, trigger, deliveryNote) {
    const drawer = document.querySelector('cart-drawer');
    const sections = drawer ? drawer.getSectionsToRender().map((s) => s.id) : [];
    addButton.disabled = true;
    addButton.setAttribute('aria-busy', 'true');
    trigger?.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(`${window.routes?.cart_add_url || `${root}cart/add`}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          // Ordered-in / made-to-order sizes carry their lead time onto the order (snippets/ls-fulfilment.liquid)
          items: [{ id: variantId, quantity: 1, ...(deliveryNote ? { properties: { Delivery: deliveryNote } } : {}) }],
          sections,
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        const message = data.description || data.message || 'Sorry, that couldn’t be added.';
        if (!sheet.hidden) status.textContent = message;
        else window.location.href = `${root}cart`;
        return;
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ls-quick-add', productVariantId: variantId, cartData: data });
      }
      document.dispatchEvent(new CustomEvent('cart:add', { detail: { variantId } }));
      close();
      if (drawer && data.sections) {
        // As Dawn's product-form does: leave the empty-cart layout before rendering items
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: variantId, sections: data.sections });
      } else {
        window.location.href = window.routes?.cart_url || `${root}cart`;
      }
    } catch (e) {
      status.textContent = 'Sorry, something went wrong. Please try again.';
    } finally {
      addButton.removeAttribute('aria-busy');
      trigger?.removeAttribute('aria-busy');
      if (state && !sheet.hidden) update();
    }
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-ls-quick-add]');
    if (trigger) {
      e.preventDefault();
      open(trigger);
    }
  });
  sheet.addEventListener('click', (e) => {
    if (e.target.closest('[data-ls-qa-close]')) close();
    if (e.target.closest('[data-ls-qa-fitcore]')) document.getElementById('fitcore-fab')?.click();
  });
  sheet.addEventListener('keyup', (e) => e.key === 'Escape' && close());
  addButton.addEventListener('click', () => {
    const variant = state && matchingVariant();
    if (variant && variant.available) add(variant.id, state.trigger, state.delivery && state.delivery[variant.id]);
  });

  // FitCore posts its result from its iframe; re-apply the new size while the sheet is open.
  window.addEventListener('message', (e) => {
    if (!e.data || e.data.type !== 'fitcore:result' || sheet.hidden || !state) return;
    setTimeout(() => {
      preselect();
      renderOptions();
      renderFit();
      update();
    }, 50);
  });
})();
